import { Formatter, openInfo } from 'gf-ui'
import React, { useState, useEffect } from 'react'
import { Container, Modal, Form, Button } from 'react-bootstrap'
import { NUMERO_DECIMALE, NUMERO_DECIMALE_NEGATIVO, NUMERO_INTERO, NUMERO_INTERO_NEGATIVO, TIPI_MODELLI } from '../constants'
import { FaCheck, FaCheckCircle, FaInfoCircle } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import BtnStampa from './BtnStampa'
import BtnContatta from './BtnContatta'
import Domande from './Domande'
import Gruppo from './Gruppo'
import TelefonoEmail from './TelefonoEmail'
import DatiMedicoReferente from './DatiMedicoReferente'

const NuovaScheda = ({ scheda, onSalvaRisposte, onAnnulla, onUpdateScheda, risultato, rottaPaginaRisultato, rottaHome, apiClient }) => {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [domande, setDomande] = useState(null);
  const [risposte, setRisposte] = useState(null);
  const [gruppi, setGruppi] = useState(null)
  const [telefono, setTelefono] = useState("")
  const [email, setEmail] = useState("")
  const [privacy, setPrivacy] = useState(false)
  const [confirmCancel, setConfirmCancel] = useState(false)
  const [showBtnContatta, toggleBtnContatta] = useState(false)
  const [showInfo, toggleInfo] = useState(false)
  const [infoMessage, setInfoMessage] = useState("")

  const onChangeSelect = (kid, val) => {
    let _domande = JSON.parse(JSON.stringify(domande));    
    let newVal = null;
    _domande.forEach((domanda, index) => {
      if (parseInt(domanda.KID) === parseInt(kid)) {
        newVal = _domande[index];
        newVal && newVal.ARR_RISPOSTE && newVal.ARR_RISPOSTE.forEach((item, index) => {
          if (parseInt(item.ID_MA_CSS_D_R) === parseInt(val)) {
            newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA = '-1';
          } else {
            newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA = '0';
          }
        })

        newVal.val = val;
      }      
    });
        
    setDomande(_domande);
  }

  const setValore = (kid, val, flgNumeric = false) => {    
    let _domande = JSON.parse(JSON.stringify(domande));
    let newVal = null;

    _domande.forEach((domanda, index) => {
      if (parseInt(domanda.KID) === parseInt(kid)) {
        newVal = _domande[index];
      }
    });
    switch (flgNumeric) {
      case false: {
        newVal.ARR_RISPOSTE[0].VALORE = val;
        newVal.val = val;
        break;
      }
      case NUMERO_INTERO:
      case NUMERO_INTERO_NEGATIVO: {
        newVal.ARR_RISPOSTE[0].VALORE = parseInt(val);
        newVal.val = parseInt(val);
        break;
      }
      case NUMERO_DECIMALE: 
      case NUMERO_DECIMALE_NEGATIVO: {
        newVal.ARR_RISPOSTE[0].VALORE = val;
        newVal.val = val && val.toString()
        break;
      }
      default: break;    
    }
    
    setDomande(_domande);
  }

  const onChangeInputNumber = (kid, val, type) => {
    setValore(kid, val, type)
  }

  const onChangeInputText = (kid, val) => {    
    setValore(kid, val)
  }

  const onChangeInputRadio = (kid, val) => {    
    onChangeSelect(kid, val);
  }

  const onChangeInputCheckbox = (kid, val) => {    
    let _domande = JSON.parse(JSON.stringify(domande));
    // let idxDomanda = null;
    let newVal = null;
    _domande.forEach((domanda, index) => {
      if (parseInt(domanda.KID) === parseInt(kid)) {
        newVal = _domande[index];        
        newVal && newVal.ARR_RISPOSTE && newVal.ARR_RISPOSTE.forEach((item, index) => {
          if (parseInt(item.ID_MA_CSS_D_R) === parseInt(val)) {
            newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA = newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA === '-1' ? '0' : '-1';
          }
        })
        newVal.val = val;

      }       
    });
    
    setDomande(_domande);
  }

  const _onSalvaRisposte = (e) => {
    e.preventDefault();

    const params = {
      SCHEDA: JSON.stringify(scheda),
      ID_MODELLO: scheda.EN_MODELLO.KID,
      TELEFONO: telefono,
      EMAIL: email,
      FLG_PRIVACY_ACCETTATA: privacy ? "-1" : "0"
    }

    if (onSalvaRisposte) {
      onSalvaRisposte(params)
    }
  }

  const onCloseInfo = () => {
    toggleInfo(false)
    onAnnulla()
  }

  useEffect(() => {
    if (domande) {
      let ris = [];
      let _gruppi = [];
      domande.forEach((domanda) => {
        if (domanda.ID_MA_GRUPPO === "") {
          _gruppi.push({
            "type": "empty",
            idGruppo: null,
            domande: [domanda]
          })
        } else {
          const _gruppo = _gruppi.filter(x => x.idGruppo === domanda.ID_MA_GRUPPO);
          if (_gruppo.length === 0) {
            _gruppi.push({
              "type": "default",
              idGruppo: domanda.ID_MA_GRUPPO,
              domande: [domanda],
              titolo: domanda.TITOLO_GRUPPO,
              descrizione: domanda.DESC_GRUPPO
            })
          } else {
            _gruppo[0].domande.push(domanda)
          }
        }
        setGruppi(_gruppi)

        // Prendo tutte le risposte selezionate della domanda
        ris = ris.concat(domanda.ARR_RISPOSTE.filter(r => Formatter.getBoolean(r.FLG_SELEZIONATA)).map(r => r.ID_MA_CSS_D_R))
      })

      setRisposte(ris)
    }

  }, [domande])

  useEffect(() => {
    if (scheda && !domande) {      
      setDomande(scheda.EN_MODELLO.ARR_DOMANDE)
    } else if (scheda && domande) {
      let _scheda = { ...scheda }
      if (JSON.stringify(_scheda.EN_MODELLO.ARR_DOMANDE) !== JSON.stringify(domande)) {
        _scheda.EN_MODELLO.ARR_DOMANDE = domande
        onUpdateScheda(_scheda)
      }
    }
  }, [domande, onUpdateScheda, scheda])

  useEffect(() => {
    if (risultato) {
      if (scheda.EN_MODELLO.ID_MA_MODELLI_TIPI === TIPI_MODELLI.PRENOTAZIONE) {

        risultato['CAT_NOTE'] = scheda.EN_MODELLO.CAT_NOTE;
        risultato['MOD_NOTE'] = scheda.EN_MODELLO.MOD_NOTE;
        risultato['MODELLO'] = scheda.EN_MODELLO.DESCRIZIONE;        
        toggleBtnContatta(risultato.FLG_CONTATTA === "-1" ? true : false)        
        navigate(rottaPaginaRisultato, { state: risultato });
        
      } else if (scheda.EN_MODELLO.ID_MA_MODELLI_TIPI === TIPI_MODELLI.RECALL) {

        onUpdateScheda({ ...scheda, KID: risultato['ID_SCHEDA'] })
        setInfoMessage(<div className="d-flex flex-column align-items-start justify-content-start">
          <div className="d-flex flex-row align-items-start justify-content-start mb-4">
            <span style={{ minWidth: '40px !important' }}><FaCheckCircle color="var(--bs-success)" /></span>
            <span className="ms-2">Scheda salvata con numero <strong>{risultato.NUMERO_ANNO}</strong></span>
          </div>
          <div className="d-flex flex-row align-items-start justify-content-start">
            <span style={{ minWidth: '40px !important' }}><FaInfoCircle color="var(--bs-primary)" /></span>
            <span className="ms-2">{scheda.EN_MODELLO.MSG_FINALE}</span></div>
        </div>)
        // <p>Per eventuali chiarimenti rivolgersi allo sportello delle malattie rare Aziendale: <a href="mailto: sportellomalattierare@ptvonline.it">sportellomalattierare@ptvonline.it</a>`)
        toggleInfo(true)

      } else {

        if (risultato.msg) {
          openInfo(dispatch, risultato.msg)
          navigate(rottaHome);
        }

      }
    }
  }, [dispatch, navigate, onUpdateScheda, risultato, rottaHome, rottaPaginaRisultato, scheda])  

  return <>

    <Container className="my-4 py-4 bg-white rounded border">

      <div>
        <h2 className="text-center text-uppercase fw-bold">{scheda.EN_MODELLO.CATEGORIA}</h2>
        <h3 className="text-center">{scheda.EN_MODELLO.DESCRIZIONE}</h3>
        <div className="text-center"><small>Compila il questionario e clicca su "Ho terminato" una volta finito</small></div>
      </div>

      <DatiMedicoReferente />      

      {scheda && scheda.EN_MODELLO.CODICE_ESENZIONE !== "" && (
        <div className="border bg-secondary text-dark rounded m-4 mb-3 p-4 fw-bold bg-light d-flex flex-row align-items-center justify-content-start">
          <div className="d-flex flex-column align-items-start">
            <div>Codice esenzione</div>
            <h5>{scheda.EN_MODELLO.CODICE_ESENZIONE}</h5>
          </div>
        </div>
      )}
      {scheda && scheda.EN_MODELLO.INTESTAZIONE !== "" && (
        <div className="mx-4 my-3 p-4 bg-light border-bottom fw-bold border rounded ">
          <label dangerouslySetInnerHTML={{ __html: scheda.EN_MODELLO.INTESTAZIONE }} />
        </div>
      )}

      <Form onSubmit={_onSalvaRisposte} className="px-0 px-md-4">
        {gruppi && gruppi.map((gruppo, index) =>
          gruppo.type === "empty" ?
            <Domande key={index}
              domande={gruppo.domande}
              risposte={risposte}
              onChangeInputNumber={onChangeInputNumber}
              onChangeInputRadio={onChangeInputRadio}
              onChangeInputCheckbox={onChangeInputCheckbox}
              onChangeInputText={onChangeInputText}
              onChangeSelect={onChangeSelect}
            />
            :
            gruppo.type === "default" ?
              <Gruppo key={index}
                gruppo={gruppo}
                risposte={risposte}
                onChangeInputNumber={onChangeInputNumber}
                onChangeInputRadio={onChangeInputRadio}
                onChangeInputCheckbox={onChangeInputCheckbox}
                onChangeInputText={onChangeInputText}
                onChangeSelect={onChangeSelect}
              />
              : <></>
        )}

        {scheda && scheda.EN_MODELLO.ID_MA_MODELLI_TIPI === TIPI_MODELLI.RECALL && (
          <section className="my-4 mx-0 px-4 bg-light" style={{ border: `1px solid ${telefono ? 'green' : 'lightgrey'}`, borderRadius: '10px' }}>
            <TelefonoEmail 
              telefono={telefono}
              onChangeTelefono={val => setTelefono(val)}
              email={email}
              onChangeEmail={val => setEmail(val)}
              privacy={privacy}
              onChangePrivacy={(val) => setPrivacy(val)}
            />
          </section>
        )}

        <Form.Group className="mb-3 mx-0 p-0 form-group">
          <div className="d-grid gap-2">
            <Button type="button" variant="outline-secondary text-dark" className="btn-lg" onClick={() => setConfirmCancel(true)}>ANNULLA</Button>
            {risposte && risposte.length > 0 && (
              <Button type="submit" variant="primary" className="btn-lg"><strong style={{ fontSize: '2rem' }}><FaCheck /> HO TERMINATO</strong></Button>
            )}
          </div>
        </Form.Group>
      </Form>
    </Container>

    {/** Modale Annulla */}
    <Modal show={confirmCancel} className="d-flex modal-dialog-centered" backdrop="static">
      <Modal.Body className="text-center modal-loading">
        <h1>Vuoi veramente uscire?</h1>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => setConfirmCancel(false)}>Annulla</Button>
        <Button variant="primary" onClick={onAnnulla} className="text-light">Conferma</Button>
      </Modal.Footer>
    </Modal>

    {/** Modale di conferma con Bottoni Stampa e Contatta */}
    <Modal show={showInfo} size="lg" className="d-flex modal-dialog-centered" backdrop="static">
      <Modal.Body className="modal-loading">
        <h3>
          {infoMessage}
        </h3>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        {scheda && (
          <BtnStampa 
          idScheda={scheda.KID}
          apiClient={apiClient}  
          modello={scheda && scheda.EN_MODELLO && scheda.EN_MODELLO.DESCRIZIONE}
          numeroScheda={risultato && risultato.NUMERO_ANNO}
          />
        )}
        {showBtnContatta && (
          <BtnContatta email={email} onChangeEmail={val => setEmail(val)} />
        )}
        <Button variant="outline-secondary" size="lg" onClick={onCloseInfo}>Chiudi</Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default NuovaScheda